import axios from 'axios';

const OPENROUTER_URL = 'https://openrouter.ai/api/v1/chat/completions';
const DEFAULT_MODEL = 'mistralai/mistral-7b-instruct';

export const sendMessage = async (message: string) => {
  const apiKey = process.env.REACT_APP_OPENROUTER_API_KEY;
  if (!apiKey) {
    throw new Error('Missing OpenRouter API key. Set REACT_APP_OPENROUTER_API_KEY in .env.');
  }

  const response = await axios.post(
    OPENROUTER_URL,
    {
      model: DEFAULT_MODEL,
      messages: [{ role: 'user', content: message }],
    },
    {
      headers: {
        Authorization: `Bearer ${apiKey}`,
        'Content-Type': 'application/json',
      },
    }
  );

  const content = response?.data?.choices?.[0]?.message?.content;
  if (!content) {
    throw new Error('Invalid AI response.');
  }

  return content as string;
};
